/* script */



















































import Vue, { PropType } from 'vue'
import { format } from 'date-fns'
import { Toa } from '../types'
import { sellersTermsOfAcquisitionPath } from '../lib/rails-routes'

const __vue_script__ = Vue.extend({
  props: {
    toa: {
      type: Object as PropType<Toa>,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    showDealSentInfo: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    toaPath(): string {
      return sellersTermsOfAcquisitionPath({ id: this.toa.id })
    },
    primaryPrefectureNames(): string {
      return this.toa.primaryPrefectureNames.slice(0, 5).join(', ')
    },
    formattedUpdatedAt(): string {
      return format(new Date(this.toa.updatedAt), 'yyyy/MM/dd')
    },
  },
  methods: {
    onRowClicked(event): void {
      if (event.target.tagName === 'A') return
      if (!this.toa.published) return

      this.$emit('click', this.toa.id)
    },
    onCheckboxClicked(event): void {
      this.$emit('change:checkbox', this.toa.id, event.target.checked)
    },
    likeClicked(): void {
      this.$emit('likeClicked', this.toa)
    },
  },
})

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      class: {
        "hover:tw-cursor-pointer": _vm.toa.published,
        "is-highlight": _vm.selected,
        "tw-bg-gray-300": !_vm.toa.published,
      },
      on: { click: _vm.onRowClicked },
    },
    [
      _c("td", { staticClass: "checkbox-cell" }, [
        _vm.toa.published
          ? _c("input", {
              attrs: { type: "checkbox" },
              domProps: { value: _vm.toa.id, checked: _vm.selected },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.onCheckboxClicked.apply(null, arguments)
                },
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("td", [
        _c("div", { staticClass: "d-md-flex" }, [
          _c("div", { staticClass: "mr-auto" }, [
            !_vm.toa.published
              ? _c(
                  "span",
                  {
                    staticClass: "badge badge-danger tw-text-xs tw-font-normal",
                  },
                  [_vm._v("募集終了")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showDealSentInfo && _vm.toa.dealSent
              ? _c("span", { staticClass: "text-muted" }, [
                  _vm._v("過去紹介有り"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "terms-of-acquisitions-table__title" },
              [
                _vm.toa.isUnread && _vm.toa.published
                  ? _c("b-badge", { attrs: { variant: "info" } }, [
                      _vm._v("未読"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.toa.published
                  ? _c(
                      "a",
                      {
                        staticClass: "js-open-remote-modal toa-title",
                        attrs: {
                          "data-title": "買収ニーズ詳細",
                          "data-url": _vm.toaPath,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.toa.title) +
                            "\n          "
                        ),
                      ]
                    )
                  : _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.toa.title) +
                          "\n          "
                      ),
                    ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right tw-shrink-0" },
            [
              _vm.toa.companyUnlisted
                ? _c(
                    "div",
                    { staticClass: "terms-of-acquisition-table__badge ml-1" },
                    [_vm._v("\n          非上場\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.toa.acquisitionTrackRecord
                ? _c(
                    "div",
                    { staticClass: "terms-of-acquisition-table__badge ml-1" },
                    [_vm._v("\n          買収実績あり\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.toa.published
                ? _c(
                    "b-btn",
                    {
                      attrs: { size: "sm", variant: "link" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.likeClicked.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm.toa.liked
                        ? _c("i", { staticClass: "fas fa-heart text-danger" })
                        : _c("i", { staticClass: "fal fa-heart" }),
                      _vm._v("\n          お気に入り\n        "),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _vm._v(_vm._s(_vm.toa.transactionValue)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _vm._v(_vm._s(this.primaryPrefectureNames)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _vm._v(_vm._s(_vm.toa.primaryIndustry)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2 text-right text-muted pr-5" }, [
            _vm._v("更新日: " + _vm._s(this.formattedUpdatedAt)),
          ]),
        ]),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-f55c59ce_0", { source: ".toa-title[data-v-f55c59ce] {\n  text-decoration: underline;\n  font-weight: bold;\n  color: #3172be;\n}\n.toa-title[data-v-f55c59ce]:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.toa-title[data-v-f55c59ce]:visited {\n  color: #3172be;\n}\ntr td[data-v-f55c59ce] {\n  padding: 5px;\n}\n.checkbox-cell[data-v-f55c59ce] {\n  height: 65px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\ntr.is-highlight[data-v-f55c59ce] {\n  background-color: lightyellow;\n}\n\n/*# sourceMappingURL=BusinessToaRow.vue.map */", map: {"version":3,"sources":["app/javascript/src/components/BusinessToaRow.vue","BusinessToaRow.vue"],"names":[],"mappings":"AAoGA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;ACnGA;ADoGA;EACA,0BAAA;EACA,eAAA;AClGA;ADoGA;EACA,cAAA;AClGA;ADuGA;EACA,YAAA;ACpGA;ADuGA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACpGA;ADuGA;EACA,6BAAA;ACpGA;;AAEA,6CAA6C","file":"BusinessToaRow.vue","sourcesContent":["<template>\n  <tr :class=\"{ 'hover:tw-cursor-pointer': toa.published, 'is-highlight': selected, 'tw-bg-gray-300': !toa.published }\" @click=\"onRowClicked\">\n    <td class=\"checkbox-cell\">\n      <input v-if=\"toa.published\" type=\"checkbox\" :value=\"toa.id\" :checked=\"selected\" @click.stop=\"onCheckboxClicked\" />\n    </td>\n    <td>\n      <div class=\"d-md-flex\">\n        <div class=\"mr-auto\">\n          <span v-if=\"!toa.published\" class=\"badge badge-danger tw-text-xs tw-font-normal\">募集終了</span>\n          <span v-if=\"showDealSentInfo && toa.dealSent\" class=\"text-muted\">過去紹介有り</span>\n          <div class=\"terms-of-acquisitions-table__title\">\n            <b-badge v-if=\"toa.isUnread && toa.published\" variant=\"info\">未読</b-badge>\n            <a\n              v-if=\"toa.published\"\n              class=\"js-open-remote-modal toa-title\"\n              data-title=\"買収ニーズ詳細\"\n              :data-url=\"toaPath\"\n              @click.prevent\n            >\n              {{ toa.title }}\n            </a>\n            <span v-else>\n              {{ toa.title }}\n            </span>\n          </div>\n        </div>\n        <div class=\"text-right tw-shrink-0\">\n          <div v-if=\"toa.companyUnlisted\" class=\"terms-of-acquisition-table__badge ml-1\">\n            非上場\n          </div>\n          <div v-if=\"toa.acquisitionTrackRecord\" class=\"terms-of-acquisition-table__badge ml-1\">\n            買収実績あり\n          </div>\n          <b-btn v-if=\"toa.published\" size=\"sm\" variant=\"link\" @click.stop=\"likeClicked\">\n            <i v-if=\"toa.liked\" class=\"fas fa-heart text-danger\" />\n            <i v-else class=\"fal fa-heart\" />\n            お気に入り\n          </b-btn>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-md-3\">{{ toa.transactionValue }}</div>\n        <div class=\"col-md-4\">{{ this.primaryPrefectureNames }}</div>\n        <div class=\"col-md-3\">{{ toa.primaryIndustry }}</div>\n        <div class=\"col-md-2 text-right text-muted pr-5\">更新日: {{ this.formattedUpdatedAt }}</div>\n      </div>\n    </td>\n  </tr>\n</template>\n\n<script lang=\"ts\">\nimport Vue, { PropType } from 'vue'\nimport { format } from 'date-fns'\nimport { Toa } from '../types'\nimport { sellersTermsOfAcquisitionPath } from '../lib/rails-routes'\n\nexport default Vue.extend({\n  props: {\n    toa: {\n      type: Object as PropType<Toa>,\n      required: true,\n    },\n    selected: {\n      type: Boolean,\n      required: true,\n    },\n    showDealSentInfo: {\n      type: Boolean,\n      default: true,\n    },\n  },\n  computed: {\n    toaPath(): string {\n      return sellersTermsOfAcquisitionPath({ id: this.toa.id })\n    },\n    primaryPrefectureNames(): string {\n      return this.toa.primaryPrefectureNames.slice(0, 5).join(', ')\n    },\n    formattedUpdatedAt(): string {\n      return format(new Date(this.toa.updatedAt), 'yyyy/MM/dd')\n    },\n  },\n  methods: {\n    onRowClicked(event): void {\n      if (event.target.tagName === 'A') return\n      if (!this.toa.published) return\n\n      this.$emit('click', this.toa.id)\n    },\n    onCheckboxClicked(event): void {\n      this.$emit('change:checkbox', this.toa.id, event.target.checked)\n    },\n    likeClicked(): void {\n      this.$emit('likeClicked', this.toa)\n    },\n  },\n})\n</script>\n\n<style lang=\"scss\" scoped>\n.toa-title {\n  text-decoration: underline;\n  font-weight: bold;\n  color: #3172be;\n  &:hover {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  &:visited {\n    color: #3172be;\n  }\n}\n\ntr {\n  td {\n    padding: 5px;\n  }\n}\n.checkbox-cell {\n  height: 65px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\ntr.is-highlight {\n  background-color: lightyellow;\n}\n</style>\n",".toa-title {\n  text-decoration: underline;\n  font-weight: bold;\n  color: #3172be;\n}\n.toa-title:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.toa-title:visited {\n  color: #3172be;\n}\n\ntr td {\n  padding: 5px;\n}\n\n.checkbox-cell {\n  height: 65px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\ntr.is-highlight {\n  background-color: lightyellow;\n}\n\n/*# sourceMappingURL=BusinessToaRow.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-f55c59ce"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/src/components/BusinessToaRow.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__